import React, { useState, useEffect } from 'react';
import './LoadingPage.css';

interface LoadingPageProps {
  onLoadingComplete: () => void;
  loadingDuration?: number;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ 
  onLoadingComplete, 
  loadingDuration = 2000 
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [shouldSlideUp, setShouldSlideUp] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldSlideUp(true);
      // スライドアップアニメーション完了後にコールバック実行
      setTimeout(() => {
        setIsLoading(false);
        onLoadingComplete();
      }, 800); // スライドアニメーション時間
    }, loadingDuration);

    return () => clearTimeout(timer);
  }, [loadingDuration, onLoadingComplete]);

  if (!isLoading) {
    return null;
  }

  return (
    <div className={`loading-container ${shouldSlideUp ? 'slide-up' : ''}`}>
      <div className="loading-content">
        <div className="loading-spinner"></div>
        <div className="loading-text">Loading...</div>
        <div className="loading-progress">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;